import { useState } from "react";
import { deviceTabs } from "@/mocks/home";

export default function DeviceSection() {
  const [activeTab, setActiveTab] = useState(deviceTabs[0].id);
  const current = deviceTabs.find((tab) => tab.id === activeTab) ?? deviceTabs[0];

  return (
    <section id="devices" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm">
            <i className="ri-device-line" />
            多设备访问
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            不同设备上的访问方式
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            同一个入口，在不同系统上的最佳用法略有差别。选择你正在使用的设备，看看对应的建议，按提示操作会更顺手。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-start">
          <div className="lg:col-span-7">
            <div role="tablist" aria-label="选择设备类型" className="flex flex-wrap gap-2">
              {deviceTabs.map((tab) => {
                const isActive = tab.id === activeTab;
                return (
                  <button
                    key={tab.id}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    onClick={() => setActiveTab(tab.id)}
                    className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                      isActive
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-100 text-foreground-700 border border-background-200 hover:bg-background-200"
                    }`}
                  >
                    <i className={`${tab.icon} text-base`} />
                    {tab.label}
                  </button>
                );
              })}
            </div>

            <div className="mt-5 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center">
                  <i className={`${current.icon} text-xl`} />
                </span>
                <h3 className="font-heading font-bold text-lg text-foreground-950">{current.label} 使用建议</h3>
              </div>
              <ul className="mt-5 flex flex-col gap-3">
                {current.points.map((point, index) => (
                  <li key={point} className="flex items-start gap-3">
                    <span className="shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-xs font-medium mt-0.5">
                      {index + 1}
                    </span>
                    <span className="text-sm md:text-base text-foreground-700 leading-relaxed">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Multiple%20devices%20laptop%20tablet%20and%20smartphone%20arranged%20on%20a%20warm%20cream%20neutral%20background%2C%20clean%20minimal%20setting%2C%20soft%20shadows%2C%20editorial%20product%20photography%2C%20warm%20cream%20and%20amber%20tones&width=1000&height=750&seq=device-91free-access&orientation=landscape"
                alt="笔记本电脑、平板与手机并排摆放，示意多设备访问入口"
                title="多设备访问 91免费 入口的方式"
                className="w-full h-56 md:h-72 object-cover object-top"
              />
            </div>
            <div className="mt-4 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
              <p className="flex items-start gap-3 text-sm text-foreground-700 leading-relaxed">
                <i className="ri-information-line text-primary-600 text-lg shrink-0 mt-0.5" />
                无论使用哪种设备，收藏的都是「本页」而不是某一条具体地址，这样任何一条线路失效时，你都能回到这里拿到更新。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}